// extracted by mini-css-extract-plugin
export var splitBlock = "splitBlock-module--split-block--B6FKt";